import React from 'react';
import { Layout, Typography, Row, Col, Divider } from 'antd';
import { FacebookFilled, TwitterCircleFilled, InstagramFilled, LinkedinFilled, MailFilled } from '@ant-design/icons';
import { logoWhite } from '../assets/assets';

const { Footer } = Layout;
const { Text, Title } = Typography;

const FooterComponent = () => {
  return (
    <Footer style={{ backgroundColor: '#2f3589', color: '#ffffff', padding: '30px 20px' }}>
      <Row justify="space-around" gutter={16} align="middle">
        {/* Sanecka Brand Info */}
        <Col xs={24} sm={12} md={8}>
          <Title level={4} style={{ color: '#ffffff' }}>Sanecka Brand</Title>
          <Text style={{ color: '#ffffff' }}>
            Discover, support, and celebrate talented artists. 
            Sanecka Brand connects creativity with opportunity.
          </Text>
        </Col>

        {/* Social Media Links */}
        <Col xs={24} sm={12} md={8} style={{ textAlign: 'center' }}>
          <Title level={4} style={{ color: '#ffffff' }}>Contact Us</Title>
          <div style={{ fontSize: '24px' }}>
            <a href="mailto:info@saneckabrand.com"  style={{ color: '#ffffff', marginRight: '15px' }}>
              <MailFilled />
            </a>
            <a href="https://facebook.com/saneckabrand" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', marginRight: '15px' }}>
              <FacebookFilled />
            </a>
            <a href="https://twitter.com/saneckabrand" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', marginRight: '15px' }}>
              <TwitterCircleFilled />
            </a>
            <a href="https://instagram.com/saneckabrand" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', marginRight: '15px' }}>
              <InstagramFilled />
            </a>
            <a href="https://linkedin.com/company/saneckabrand" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff' }}>
              <LinkedinFilled />
            </a>
          </div>
        </Col>
        

        <Divider />

        {/* Powered by Tanzator */}
        <Col xs={24} sm={24} md={24} style={{ textAlign: 'center' , display:'inline', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
          <Text style={{ color: '#ffffff', fontSize: '14px', verticalAlign:'top' }}>&copy; {new Date().getFullYear()} Sanecka Brand. All rights reserved. </Text>
          <Text style={{ color: '#ffffff', fontSize: '14px', verticalAlign:'top' }}>Powered by</Text>
          {/* <div style={{ display: 'flex', alignItems: 'center', }}> */}
          <a href="https://tanzator.com" target="_blank" rel="noopener noreferrer">
            <img
              src={logoWhite}
              alt="Tanzator Logo"
              style={{ height: '30px', marginRight: '10px', marginLeft: '10px' }}
              />
            <Text style={{ color: '#ffffff', fontSize: '14px', verticalAlign:'top' }}>Tanzator</Text>
              </a>
          {/* </div> */}
        </Col>
      </Row>
    </Footer>
  );
};

export default FooterComponent;
